// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HXC4_IGvL9knuR {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.TCn0aYr9R4P0tE {
  flex-grow: 0;
  padding-top: 40px;
}
.UwsyJpIl6LcGYi {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
  padding: 24px 0;
}
.AFZWMZkxufMoM3 {
  margin: 0;
  color: var(--ds-text-subtle, #44546f);
  text-align: center;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"TemplateStoryErrorContainer": `HXC4_IGvL9knuR`,
	"errorPageImage": `TCn0aYr9R4P0tE`,
	"errorMessageContainer": `UwsyJpIl6LcGYi`,
	"errorMessage": `AFZWMZkxufMoM3`
};
export default ___CSS_LOADER_EXPORT___;
